export const environment = {
  production: false,
  basePath: 'https://solaridms-dev-api.rainbow.health/api',
  tenant: 'rcdms012',
  supportedCountry: ['IN', 'US'],
  idleTimeEnable: true,
  signInVersion: '3.0.0',
  firebase: {
    apiKey: "AIzaSyCB4VP9b2u1MPnY75IvwgMlukvb-W2AUCw",
    authDomain: "solari-dms-lower-env.firebaseapp.com",
    projectId: "solari-dms-lower-env",
    storageBucket: "solari-dms-lower-env.firebasestorage.app",
    messagingSenderId: "369345479731",
    appId: "1:369345479731:web:6756ca9a7c8b6a45854f46",
    measurementId: "G-EF1CS8D7M6"
  }
};
